import React from 'react';

import { RichTextarea } from '@dashboard/components/Formik';
import { buildEmailVariables } from '@dashboard/lib/emailVariables';

const ConfirmationCheckoutMessageEditor = ({
  id,
  name,
  values,
  page,
  setFieldValue,
  initialValue,
  appearance,
  reminderEmail = false,
  confirmationEmail = false,
}) => {
  const variables = buildEmailVariables({ page, reminderEmail, confirmationEmail });

  return (
    <RichTextarea
      id={id}
      name={name}
      values={values}
      setFieldValue={setFieldValue}
      variables={variables}
      initialValue={initialValue}
      appearance={appearance}
    />
  );
};

export default ConfirmationCheckoutMessageEditor;
